module.exports = __webpack_public_path__ + "img/syukyaku-top-004.bf1f5376.jpg";